<template>
	<van-swipe
		ref="swipe"
		class="swipe-wrapper"
		:loop="loop"
		:autoplay="autoplay"
		:touchable="touchable"
		:showIndicators="showIndicators"
		@change="changeHandler"
		indicator-color="white"
	>
		<van-swipe-item v-for="(slotName, idx) in innerSlots" :key="idx">
			<slot :name="slotName" />
		</van-swipe-item>
	</van-swipe>
</template>

<script>
	import Vue from 'vue'
	import {Swipe, SwipeItem} from 'vant'
	
	Vue.use(Swipe)
	Vue.use(SwipeItem)
	
	export default {
		name: 'swipe',
		
		props: {
			autoplay: {
				type: [String, Number],
				default: 3 * 1000
			},
			
			duration: {
				type: [String, Number],
				default: 500
			},
			
			loop: {
				type: Boolean,
				default: true
			},
			
			touchable: {
				type: Boolean,
				default: true
			},
			
			showIndicators: {
				type: Boolean,
				default: false
			}
		},
		
		computed: {
			innerSlots(){
				return Object.keys(this.$slots).filter(slotName => {
					return slotName.includes('swipe-slot-')
				})
			}
		},
		
		methods: {
			changeHandler(idx){
				this.$emit('change', idx)
			},
			
			prev(){
				this.$refs.swipe.prev()
			},
			
			next(){
				this.$refs.swipe.next()
			},
			
			swipeTo(idx, {immediate = false} = {}){
				this.$refs.swipe.swipeTo(idx, {immediate})
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.swipe-wrapper{
		height: 100%;
		
		.van-swipe{
			height: 100%;
		}
	}
</style>
